module.exports = __webpack_public_path__ + "img/edelstahltreppengelaender.749cf1a5.webp";